import React from 'react';

const UserHeader = () => {
  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
      <div>
        <h1 className="text-3xl font-bold text-slate-900">User Management</h1>
        <p className="mt-2 text-gray-600 max-w-2xl">
          Create, edit, and deactivate branch staff. Assign each user to one branch and choose a role.
        </p>
      </div>
    </div>
  );
};

export default UserHeader;